<h2 mat-dialog-title>Add {{childType}}</h2>
<mat-dialog-content>
  <div style="padding: 10px 0; width: 100%;">
    <app-dynamic-forms-v2 
      #formRef
      [formMetaData]="formMetaData" 
      [formFields]="formFields"
      (onEveryChange)="onFormChange($event)">
    </app-dynamic-forms-v2>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="submitting">Cancel</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="submitting">
    {{ submitting ? 'Saving...' : 'Save' }}
  </button>
</mat-dialog-actions>
